/** Machine values from the form → copy for API payload (sheet / emails). */
const PARTICIPATION_TYPE_LABELS: Record<string, string> = {
    adult_2_days: 'Adult – 2 days (Saturday–Sunday)',
    adult_3_days: 'Adult – 3 days',
    children_2_days: 'Child – 2 days (Friday–Saturday)',
    Adult: 'Adult',
    Children: 'Child',
};

export function participationTypeLabel(participationType: string): string {
    if (!participationType) return '';
    return PARTICIPATION_TYPE_LABELS[participationType] ?? participationType;
}
